export class GetClientsByIdRequest {
    public key: string = "getClientsById";
    constructor(
        public payload: string[] = [],
    ) { }
}